export function updatePendoCustomer(customer) {
  try {
    const pendo = window.pendo;

    if (!pendo) {
      return;
    }

    const {customerInfo: {
      cid, companyName, state, city
    }} = customer

    pendo.updateOptions({
      account: {
        id: cid,
        name: companyName,
        state,
        city
      }
    });

    pendoTrackCustomerInformation();
  } catch (error) {
    console.error(error);
  }
}

export function changePendoUser(user) {
  try {
    const pendo = window.pendo;

    if (!pendo) {
      return;
    }

    pendo.initialize({
      visitor: {
        id: user.userId,
        name: user.userName,
        email: user.email
      },
      account: {
        id: user.customerId
      }
    });
  } catch (error) {
    console.error(error);
  }
}

export function pendoTrackCustomerInformation() {
  try {
    const pendo = window.pendo;

    if(!pendo) {
      return;
    }
    
    const resolution = `${window.screen.width}x${window.screen.height}`;

    pendo.track('customerInformation', {
      resolution: resolution,
      userAgent: navigator.userAgent
    });
  } catch (error) {
    console.log(error);
  }
}